var React = require('react');

function EyeOpenInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M1 12c2.567-4.667 6.233-7 11-7s8.433 2.333 11 7c-2.933 4.667-6.6 7-11 7s-8.067-2.333-11-7z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.82 5.696C9.104 5.232 10.497 5 12 5c1.503 0 2.896.232 4.18.696a6 6 0 1 1-8.36 0zM10.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z","fill":"currentColor","key":1})]));
}

EyeOpenInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = EyeOpenInline;

EyeOpenInline.default = EyeOpenInline;
